import { createFileRoute } from '@tanstack/react-router';
import { emailScheduledQueryOptions } from '@utils/queryOptions';
import EmailScheduledDetails from '@Views/Emails/scheduled/details';

export const Route = createFileRoute('/emails/scheduled/$scheduledId')({
    component: EmailScheduledDetails,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailScheduledQueryOptions(opts.params.scheduledId),
        ),
});
